exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mobile thead[data-v-57fcf554] {\n  line-height: 1;\n}\n.mobile .calculator__amortization-body td[data-v-57fcf554] {\n  font-size: 0.7rem;\n}\n", ""]);

// exports
